import { Avatar, Card } from 'antd';
import React, { FC, useMemo } from 'react';
import { ContactAvatar } from '../contact_avatar/ContactAvatar';
import { connect } from 'react-redux';
import { nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import { ROLE_TYPES } from '../../utils/DataConstants';
import { getInitials } from '../../utils/DataFormatterUtils';
import { getAvatarStyle } from '../../utils/ImageUtils';
import { getContractorWO } from '../../utils/WorkOrderUtils';

require('./WorkOrdersDetailDetailsPage.less');

const getFacilityInchargeContactsForWOLocation = (workOrder) =>
	nullSafeGet('location.facilityInChargeContacts.0', workOrder)
		? nullSafeGet('location.facilityInChargeContacts', workOrder)
		: nullSafeGet('location.facilityInChargeEmails.0', workOrder)
		? nullSafeGetOrElse('location.facilityInChargeEmails', workOrder, []).map((email) => ({
				email,
		  }))
		: [];

export const getAllInternalContactsForWO = (workOrder, isClientView = true) => {
	const facilityInchargeContacts = getFacilityInchargeContactsForWOLocation(workOrder);
	//Getting it for client view,
	const contractorWO = getContractorWO(workOrder, isClientView);
	const customerContact = nullSafeGet('contractorCreatedByContact', contractorWO);
	if (contractorWO) {
		return customerContact ? [customerContact] : [];
	} else if (nullSafeGet('isPM', workOrder) && facilityInchargeContacts.length > 0) {
		return facilityInchargeContacts;
	} else if (nullSafeGet('createdByContact', workOrder)) {
		return [nullSafeGet('createdByContact', workOrder)];
	}
	return [];
};

const WorkOrderInternalContact: FC<any> = ({
	userType,
	workOrder,
	isClientView,
}): React.ReactElement => {
	const allContacts = useMemo(
		() => getAllInternalContactsForWO(workOrder, isClientView),
		[isClientView, workOrder]
	);

	const isSupplier = useMemo(() => userType === ROLE_TYPES.SUPPLIER, [userType]);

	if ((!allContacts || allContacts.length === 0) && nullSafeGet('submittedByName', workOrder)) {
		return (
			<div className="mb-2">
				<Card title={isSupplier ? 'Customer Contact' : 'Internal Contact'}>
					{nullSafeGet('submittedByName', workOrder) ? (
						<div className="materialCard__flexCentVert" style={{ marginBottom: 24 }}>
							<Avatar style={getAvatarStyle(nullSafeGet('submittedByName', workOrder))}>
								{getInitials(nullSafeGet('submittedByName', workOrder), '')}
							</Avatar>
							<div className="ml-4">
								<div className="materialCard__title">
									{nullSafeGet('submittedByName', workOrder)}
								</div>
							</div>
						</div>
					) : null}
				</Card>
			</div>
		);
	}

	return allContacts.map((contact, idx) => (
		<div key={`contact-${idx}`} className="mb-2">
			<Card title={isSupplier ? 'Customer Contact' : 'Internal Contact'}>
				{nullSafeGet('nameGiven', contact) ||
				nullSafeGet('nameFamily', contact) ||
				nullSafeGet('submittedByName', workOrder) ? (
					<div className="materialCard__flexCentVert" style={{ marginBottom: 24 }}>
						<ContactAvatar
							size="large"
							hidePopover={true}
							style={{ marginRight: 16 }}
							contact={contact}
							userType={userType}
						/>
						<div>
							<div className="materialCard__title">
								{nullSafeGetOrElse(
									'submittedByName',
									workOrder,
									`${nullSafeGetOrElse('nameGiven', contact, '')} ${nullSafeGetOrElse(
										'nameFamily',
										contact,
										''
									)}`
								)}
							</div>
							<div className="materialCard__subtitle">
								{nullSafeGet('title', contact)} {nullSafeGet('department', contact)}
							</div>
						</div>
					</div>
				) : null}
				{nullSafeGet('phoneWork', contact) && (
					<div
						className="materialCard__supportingText materialCard__flexCentVert"
						style={{ marginBottom: 8 }}
					>
						<div className="materialCard__iconLabel">
							<i style={{ fontSize: 24 }} className={`icons8-font icons8-phone`} />
						</div>
						<div>{nullSafeGet('phoneWork', contact)}</div>
					</div>
				)}
				{nullSafeGet('phoneMobile', contact) && (
					<div
						className="materialCard__supportingText materialCard__flexCentVert"
						style={{ marginBottom: 8 }}
					>
						<div className="materialCard__iconLabel">
							<i style={{ fontSize: 24 }} className={`icons8-font icons8-cell-phone`} />
						</div>
						<div>{nullSafeGet('phoneMobile', contact)}</div>
					</div>
				)}
				{nullSafeGet('email', contact) && (
					<div
						className="materialCard__supportingText materialCard__flexCentVert"
						style={{ marginBottom: 8 }}
					>
						<div className="materialCard__iconLabel">
							<i style={{ fontSize: 24 }} className={`icons8-font icons8-secured-letter-filled`} />
						</div>
						<div>{nullSafeGet('email', contact)}</div>
					</div>
				)}
			</Card>
		</div>
	));
};

const mapStateToProps = (state) => ({
	isClientView: state.clientView.isClientView,
});

const ComponentWithoutUserType = connect(mapStateToProps)(WorkOrderInternalContact);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(ComponentWithoutUserType);
